import { useTenantStore } from '@/store/tenant.store.js';

export class ReportingArchiveIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async list(params = {}) {
        if (!useTenantStore.getState().selectedTenantId) return { success: false, data: [] };
        try {
            return await this.service.getAll(params);
        } catch (error) {
            return { success: false, data: [], error: error.message };
        }
    }
}
